<!--
 * @title: 页面名称
 * @Description: 
 * @Version: 2.0
 * @Autor: 研发三部
 * @Date: 2020-12-03 09:37:11
 * @LastEditors: jinzb
 * @LastEditTime: 2020-12-28 16:01:28
-->
<template>
  <div class="content1">
    <div class="block" style="width: 26.6%;">
      <span class="resource-title" @click="changeActiveComponents('resourceStatus')">
        <!-- <i class="el-icon-minus title_icon"></i> -->
        <span style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1.2vw;margin-left: 3%;">▎</span>草地型</span>
      <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: calc(100% - 40px);">

        <div style="height: 100%">
          <div style="
                margin: 0 5%;
                height: 14%;
                font-size: 1vw;
                color: #fff;
                position: relative;
                top: 0px;
                left: 0px;
              ">
            <div style="
                  height: 100%;
                  position: absolute;
                  top: 2%;
                  left: 5%;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  flex-direction: column;
                ">
              <div>
                草地面积：&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #00fefd; font-size: 1.2vw; padding-left: 5%">{{
                  areaAndType.grasslandArea }} 万亩</span>
              </div>
              <div>
                草地类型：&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #00fefd; font-size: 1.2vw; padding-left: 5%">{{
                  areaAndType.rangeland }} 类 {{ areaAndType.grasslandType }} 型</span>
              </div>
            </div>
          </div>

          <div style="margin: 0 5%; height: 43%">

            <v-chart :option="rangelandChart" autoresize style="width:100%;height:100%" />
          </div>
          <div style="margin: 0 5%; height: 43%">
            <v-chart :option="typeChart" autoresize style="width:100%;height:100%" />
          </div>
        </div>
      </dv-border-box-1>
    </div>
    <div class="block" style="width: 46.6%;">

      <div style="height: 55%; width: 100%; border-radius: 10px" class="map_image">
        <el-carousel :interval="6000" arrow="always" style="height: 100%">
          <el-carousel-item v-for="item in mapImages" style="height: 100%">
            <div class="image_title"></div>
            <div style="width: 100%; height: 90%;position: relative;">

              <el-image class="imageBox6" :preview-src-list="mapImages.map(ele=> ele.url)" :src=" item.url" fit="contain" style="width: 100%; height: 100%;">

              </el-image>

              <div style="position: absolute;top: -9%;left:  40%;" class="image_title"> {{ item.name }} </div>



            </div>

          </el-carousel-item>
        </el-carousel>
      </div>
      <div style="height: 45%; width: 100%">
        <span class="resource-title" @click="changeActiveComponents('pestStatus')">
          <!-- <i class="el-icon-minus title_icon"></i> -->
          <span style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1.2vw;margin-left: 3%;">▎</span>草原类</span>
        <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: calc(100% - 40px);">
          <!-- <centerLeft1 /> -->
          <div style="width: 100%;height: 100%;display: flex;justify-content: center;">
            <div style="height: 100%;margin: 0 0%;width: 90%;">
              <div style="height: 8%;"></div>
              <!-- <dv-scroll-board :key="scrollBoardKey" :config="config" style="width:100%;height:85%; " /> -->

              <div style="width: 100%;height: 84%;background-color1: red;">
                <tabulationCarousel  v-if="tableColumn.length > 0 && tableCollect.length > 0 && tableData.length > 0"
                  :tableColumn="tableColumn" :tableCollect="tableCollect" :tableData="tableData"
                  style="width: 100%;height: 100%;background-color1: brown;"></tabulationCarousel>
              </div>

              <div style="height: 8%;"></div>
            </div>
          </div>
        </dv-border-box-1>
      </div>
      <!-- <dv-border-box-12 style="height: 45%;">
                          <div style=" padding: 16px;height: 100%;width: 100%;border-radius: 10px;">
                          </div>
                      </dv-border-box-12> -->
      <!-- <div style="border: 1px #00ffff solid; height: 45%;width: 100%;border-radius: 10px;">
                          image
                      </div> -->
    </div>
    <div class="block" style="width: 26.6%;">
      <span class="resource-title" @click="changeActiveComponents('ecologicalCondition')">
        <!-- <i class="el-icon-minus title_icon"></i> -->
        <span style="height: 100%;font-weight: 800;color: #00ffff;font-size: 1.2vw;margin-left: 3%;">▎</span>草原等级</span>
      <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: calc(100% - 40px);">

        <div style="margin: 0 5%; height: 100%">
          <div style="height: 50%">

            <div style="height: 100%">
              <div style="display: flex;align-items: center; height: 20%;
                font-size: 1vw;
                color: #fff;
                ">

                <div style="
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  flex-direction: column;
                ">
                  <div style="height: 100%;margin-left: 5%;">
                    草原等
                  </div>

                </div>
              </div>
              <v-chart :option="steppeTableChart" autoresize style="width:100%;height:80%;" />
            </div>
          </div>
          <div style="height: 50%">

            <div style="
                height: 14%;
                font-size: 1vw;
                color: #fff;
                position: relative;
                top: 0px;
                left: 0px;">
              <div style="
                  height: 100%;
                  position: absolute;
                  top: 29%;
                  left: 5%;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  flex-direction: column;">
                <div style="height: 100%">
                  草原等级
                </div>
              </div>
            </div>
            <div style="height: 86%">
              <!-- <Chart :cdata="vegetationCoverageChart" /> -->
              <v-chart :option="grasslandGradeChart" autoresize style="width:100%;height:100%" />
            </div>

            <!-- <div style="height: 100%">

              <v-chart :options="grasslandGradeChart" autoresize style="width:100%;height:100%" />
            </div> -->
          </div>
        </div>
      </dv-border-box-1>
    </div>
  </div>
</template>
<script>
import leftTop from "../comp/shouye/leftTop.vue";
import leftBottom from "../comp/shouye/leftBottom.vue";
import rightBottom from "../comp/shouye/rightBottom.vue";
import rightTop from "../comp/shouye/rightTop.vue";
// import Chart from "../echarts/bar.vue";
import PieChart from "../echarts/pie.vue";

import * as api from "@/api/cloud-screen";
import CFG from "@/config/config";

import tabulationCarousel from "../carousel/tabulation-carousel.vue";





export default {
  components: {
    leftTop,
    leftBottom,
    rightBottom,
    rightTop,
    // Chart,
    PieChart,
    tabulationCarousel

  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    maptype: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      w: 0,
      h: 0,
      tableCollect: [],
      tableColumn: [],
      tableData: [],
      config: {
        header: ['县类名称'],
        data: [

        ],
        // headerBGC: "rgba(0, 128, 128,0.8)",
        // oddRowBGC: "rgba(0, 128, 128,0.59)",
        // evenRowBGC: "rgba(0, 128, 128,0.59)"
        headerBGC: "rgba(14, 45, 40,0.8)",
        oddRowBGC: "rgba(14, 45, 40,0.59)",
        evenRowBGC: "rgba(14, 45, 40,0.59)"
      },
      urlprefix: CFG.LOTIP,
      areaAndType: {
        grasslandArea: "-",
        grasslandType: "-",
        rangeland: "-",
      },
      rangelandChartX: [],
      rangelandChartY: [],
      rangelandChartIndex: 4,
      rangelandChartInterval: null,
      rangelandChart: {
        legend: {
          show: false
        },
        grid: {
          left: "20px",
          right: "20px",
          bottom: "20px",
          top: "30px",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}:{c0}万亩"
        },
        xAxis: {
          type: "category",
          data: [
            // "高寒草原类",
            // "高寒荒漠类",
            // "高寒草甸类",
            // "低地草甸类",
            // "山地草甸类",
            // "温性典型草原类",
            // "温性荒漠类",

          ],
          axisLabel: {
            interval: 0,
            show: true,
            rotate: 20,
            textStyle: {
              color: "#fff"
            },
            align: 'center',
            margin: 20,
            fontSize: 11
          },
          axisLine: {
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          }
        },
        dataZoom: {
          show: true,
          realtime: true,
          start: 0,
          type: "inside",
          end: 100,
          backgroundColor: "rgba(19,227,227,0.3)"
        },

        yAxis: {
          name: "万亩",
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            show: "true",

            textStyle: {
              color: "#fff",
              fontSize: 10
            }
          },

          axisLine: {
            show: true,
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          },
          axisTick: {
            show: false // 是否显示刻度线
          },
          axisLabel: {
            show: false // 是否显示刻度标签
          },
          nameTextStyle: {
            fontSize: 14,
            fontWeight: 800
          },
        },
        series: {
          data: [], //this.dataSource.ydata[0].data,
          type: "bar",
          barWidth: "50%",
          label: {
            show: true,
            position: "top",
            color: "#fff"
          },
          itemStyle: {
            //  color: "#0099FF",

            normal: {
              // 随机显示
              // color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}

              // 定制显示（按顺序）
              color: function (params) {
                var colorList = [
                  "rgb(0,133,168)",
                  "rgb(158,188,216)",
                  "rgb(190,255,231)",
                  "rgb(77,230,0)",
                  "rgb(233,255,190)",
                  "rgb(103,119,206)",
                  "rgb(122,182,245)"
                ];
                let colorItem = colorList[params.dataIndex];
                return colorItem;
              },
              fontSize: 11
            }
          }
        }
      },
      typeChart: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} <br/> {c}万亩 ({d}%)",
          // position: ['10%', '50%']
        },
        grid: {
          left: "10",
          right: "25px",
          bottom: "100",
          top: "30px",
          containLabel: true,
          // show:true
        },
        legend: {
          show: true,
          bottom: 20,
          // left: 0,
          // type: 'scroll',
          orient: 'horizontal',
          // right: "20%",
          textStyle: {
            color: "#fbfffd"
          },
          icon: "circle",
          pageIconColor: "#00FFFF",
          pageTextStyle: {
            color: "#00FFFF"
          },
          pageIconSize: [10, 10],
          itemWidth: 10,
          selectorButtonGap: 5,
          selectorItemGap: 2,
          selectorLabel: {

            overflow: 'truncate',
            width: 20

          }
        },


        series: [
          {
            name: "草地型",
            type: "pie",
            minAngle: 5,
            avoidLabelOverlap: true,
            radius: [0, "45%"],

            // avoidLabelOverlap:
            label: {
              width: 20,

              overflow: 'break',
              fontSize: 10,
              normal: {
                // formatter: "{c|{c}万亩}\n {d|{d}%}",
                formatter: "{c|{c}}\n {d|{d}%}",
                // formatter: "{d|{d}%}",
                rich: {
                  c: {
                    color: "#fff"
                  },
                  d: {
                    color: "#00ffe4"
                  }
                }
              }
            },
            labelLine: {
              normal: {
                show: true,

                length: 1
              }
            },





            data: [
            ],
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = [
                    "#f57a7a",
                    "#e69800",
                    "#ffd37f",
                    "#ffaa00",
                    "#ffaa00",
                    "#f5ca7a",
                    "#a87000",
                    "#73b2ff",
                    "#00c5ff",
                    "#94e3ff",
                    "#7a8ef5",
                    "#73dfff",
                    "#444f89",
                    "#6677cd",
                    "#5677cd",
                    "#4677cd",
                    "#3677cd",
                    "#2677cd",
                    "#1677cd",
                    "#73dfff",
                    "#d1f0f1",
                    "#d1f1f2",
                  ];
                  return colorList[params.dataIndex];
                }
              }
            },
            center: ["50%", "35%"] // 这个属性调整图像的位置！！！！！
          }
        ]
      },

      grasslandClassChart: {
        title: {
          text: '草原级',
          left: "10",
          top: "0",
          textStyle: {
            color: '#fff',
          }
        },
        legend: {
          show: false
        },
        grid: {
          left: "20px",
          right: "20px",
          bottom: "20px",
          top: "60px",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}:{c0}万亩"
        },
        xAxis: {
          type: "category",
          data: [
            // "高寒草原类",
            // "高寒荒漠类",
            // "高寒草甸类",
            // "低地草甸类",
            // "山地草甸类",
            // "温性典型草原类",
            // "温性荒漠类",

          ],
          axisLabel: {
            show: true,
            rotate: 0,
            textStyle: {
              color: "#fff"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          }
        },
        dataZoom: {
          show: true,
          realtime: true,
          start: 0,
          type: "inside",
          end: 100,
          backgroundColor: "rgba(19,227,227,0.3)"
        },

        yAxis: {
          name: "万亩",
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            show: "true",

            textStyle: {
              color: "#fff",
              fontSize: 10
            }
          },

          axisLine: {
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          }
        },
        series: {
          data: [], //this.dataSource.ydata[0].data,
          type: "bar",
          label: {
            show: true,
            position: "top",
            color: "#fff"
          },
          itemStyle: {
            normal: {
              // 随机显示
              // color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}
              // 定制显示（按顺序）
              color: function (params) {
                var colorList = [
                  "rgb(0,133,168)",
                  "rgb(158,188,216)",
                  "rgb(190,255,231)",
                  "rgb(77,230,0)",
                  "rgb(233,255,190)",
                  "rgb(103,119,206)",
                  "rgb(122,182,245)"
                ];
                let colorItem = colorList[params.dataIndex];
                return colorItem;
              }
            }
          }
        }
      },
      degradationChart: {
        legend: {
          bottom: 0,
          // type: "scroll",
          textStyle: {
            color: "#fbfffd"
          },
          pageIconColor: "#00FFFF",
          pageTextStyle: {
            color: "#00FFFF"
          }
        },
        grid: {
          left: "30px",
          right: "25px",
          bottom: "110px",
          top: "10px",
          containLabel: true
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c}万亩<br/>占比： {d}%"
        },
        series: [
          {
            name: "草原退化",
            type: "pie",
            // radius: [0, 80],
            center: ["50%", "50%"],

            itemStyle: {
              color: "#c23531",
              shadowBlur: 200,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            label: {
              fontSize: 10,
              normal: {
                formatter: "{c|{c}万亩}\n {d|{d}%}",
                rich: {
                  c: {
                    color: "#fff"
                  },
                  d: {
                    color: "#00ffe4"
                  }
                }
              }
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            data: [],
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = {
                    "无退化": "#38a800",
                    "轻度退化": "#ffd37f",
                    "中度退化": "#e69800",
                    "重度退化": "#ff0000",
                  };
                  let color = colorList[params.name] ? colorList[params.name] : "#a3ff73"
                  return color;
                }
              }
            }
          }
        ]
      },
      steppeTableChart: {
        // title: {
        //   text: '草原等',
        //   left: "10",
        //   top: "20",
        //   textStyle: {
        //     color: '#fff',
        //   }
        // },
        legend: {
          show: true,
          bottom: 10,
          // left: 0,
          // type: "scroll",
          textStyle: {
            color: "#fbfffd"
          },
          pageIconColor: "#00FFFF",
          pageTextStyle: {
            color: "#00FFFF"
          },
          // width: "10px",
          // itemWidth: 10,
          icon: "circle",
          orient: 'horizontal',
          itemWidth: 10,

          // padding: [0, 0]
        },
        grid: {
          left: "30px",
          right: "25px",
          bottom: "110px",
          top: "10px",
          containLabel: true
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c}万亩<br/>占比： {d}%"
        },
        series: [
          {
            name: "草原等",
            type: "pie",
            radius: [0, "45%"],
            center: ["50%", "40%"],

            itemStyle: {
              color: "#c23531",
              shadowBlur: 200,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            label: {


              fontSize: 10,
              normal: {
                formatter: "{c|{c}万亩}\n {d|{d}%}",
                rich: {
                  c: {
                    color: "#fff"
                  },
                  d: {
                    color: "#00ffe4"
                  }
                }
              }
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            data: [],
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = ["#38a801", "#8bd100", "#ffff00", "#fc7a05", "#fd0c09"];
                  return colorList[params.dataIndex];
                  // return color;
                }
              }
            }
          }
        ]
      },
      vegetationCoverageChart: {
        legend: {
          show: false
        },
        grid: {
          left: "30px",
          right: "25px",
          bottom: "15px",
          top: "30px",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}:{c0}万亩<br/>"
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            show: "true",
            rotate: 0,
            textStyle: {
              color: "#fff"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          }
        },
        dataZoom: {
          show: true,
          realtime: true,
          start: 0,
          type: "inside",
          end: 100
        },

        yAxis: {
          name: "万亩",
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            show: "true",

            textStyle: {
              color: "#fff",
              fontSize: 10
            }
          },
          axisLine: {
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          }
        },
        series: {
          data: [0.10,
            200.91,
            385.42,
            139.07,
            27.83,
            3.61
          ],
          type: "bar",
          // barMaxWidth: 20,
          label: {
            show: true,
            position: "top",
            color: "#fff"
          },
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = [
                  "#09f709",
                  "#22DD48",
                  "#38a800",
                  "#79c900",
                  "#ceed00",
                  "#ffcc00",
                  "#ff6600",
                  "#ff0000"
                ];
                return colorList[params.dataIndex];
              }
            }
          }
        }
      },

      grasslandGradeChart: {
        // title: {
        //   text: '草原等级',
        //   left: "10",
        //   top: "0",
        //   textStyle: {
        //     color: '#fff',
        //   }
        // },
        legend: {
          show: false
        },
        grid: {
          left: "20px",
          right: "20px",
          bottom: "20px",
          top: "50px",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}:{c0}万亩"
        },
        xAxis: {
          type: "category",
          data: [
          ],
          axisLabel: {
            show: true,
            rotate: 20,
            textStyle: {
              color: "#fff"
            },
            align: 'center',
            margin: 20,
            fontSize: 11
          },
          axisLine: {
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          }
        },
        dataZoom: {
          show: true,
          realtime: true,
          start: 0,
          type: "inside",
          end: 100,
          backgroundColor: "rgba(19,227,227,0.3)"
        },

        yAxis: {
          name: "万亩",
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            show: "true",

            textStyle: {
              color: "#fff",
              fontSize: 11
            }
          },

          axisLine: {
            show: true,
            lineStyle: {
              color: "#00CCFF",
              width: 2
            }
          },
          axisTick: {
            show: false // 是否显示刻度线
          },
          axisLabel: {
            show: false // 是否显示刻度标签
          },
          nameTextStyle: {
            fontSize: 14,
            fontWeight: 800
          },
        },
        series: {

          data: [], //this.dataSource.ydata[0].data,
          type: "bar",
          barWidth: "50%",
          label: {
            show: true,
            position: "top",
            color: "#fff"
          },
          itemStyle: {
            //  color: "#0099FF",

            normal: {
              // 随机显示
              // color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}

              // 定制显示（按顺序）
              color: function (params) {
                var colorList = [
                  "#FFFF00",
                  "#6FC400",
                  "#B0E000",
                  "#38A800",
                  "#FFAA00",
                  "rgb(103,119,206)",
                  "rgb(122,182,245)"


                ];
                let colorItem = colorList[params.dataIndex];
                return colorItem;
              },
              fontSize: 11
            }
          }
        }
      },
      cdata: {
        category: [
          "高寒草甸类",
          "高寒草原类",
          "高寒荒漠类",
          "温性典型草原类",
          "温性荒漠类",
          "低地草甸类",
          "山地草甸类",
        ],
        lineData: [0, 0, 0, 78162.58, 0, 21563.16, 0],
        title: "草原类",
        yAxisUnit: "万亩",
        rateData: [],
      },

      // rangelandChart: {
      //   category: [],
      //   lineData: [],
      //   title: "草原类",
      //   yAxisUnit: "万亩",
      //   rateData: [],
      // },
      // typeChart: {
      //   category: [],
      //   lineData: [],
      //   title: "草原型",
      //   yAxisUnit: "万亩",
      //   rateData: [],
      // },
      // grasslandGradeChart: {
      //   category: [],
      //   lineData: [],
      //   title: "草原等级",
      //   yAxisUnit: "万亩",
      //   rateData: [],
      // },

      // grasslandClassChart: {
      //   category: [],
      //   lineData: [],
      //   title: "草原级",
      //   yAxisUnit: "万亩",
      //   rateData: [],
      // },
      // degradationChart: {
      //   xData: [],
      //   seriesData: [],
      // },
      degradationArea: 0,
      // vegetationCoverageChart: {
      //   category: [],
      //   lineData: [],
      //   title: "",
      //   yAxisUnit: "%",
      //   rateData: [],
      // },
      avgCoverage: 0,
      mapImages: [],
      pestData: [],
      conf: null,

      fileList: [
        {
          name: "food.jpeg",
          url:
            "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
        {
          name: "food2.jpeg",
          url:
            "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
        {
          name: "1.jpeg",
          url:
            "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },

      ],
      fileList1: [
        {
          name: "food.jpeg",
          url:
            "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
        {
          name: "food2.jpeg",
          url:
            "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
        {
          name: "1.jpeg",
          url:
            "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
        {
          name: "food2.jpeg",
          url:
            "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
        {
          name: "1.jpeg",
          url:
            "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },

      ],
      scrollBoardKey: 0
    };
  },
  watch: {},
  async mounted() {
    // setInterval(() => {
    //   this.getH()
    //   this.getW()
    // }, 5000);
    let that = this
    window.addEventListener('resize', () => {

      this.$nextTick(() => {
        that.scrollBoardKey = that.scrollBoardKey + 1
      })
    })
    console.log(this.$route.query);
    console.log(this.$route.params.systemSid);

    console.log(this.conf, "conf=================");

    // setTimeout(() => {
    //   console.log(this.conf,"conf=================")
    //           }, 5000);

    let data = await api.getConfig(this.$route.params.systemSid);
    console.log(data, "mmmmmmmmmmmm");
    if (data.resp_code == "10000") {
      this.conf = data.data;
    }

    this.getAreaAndType();
    this.getRangelandChart();
    // this.getGrasslandClassChart();
    this.getTypeChart()
    // this.getRangelandTable()
    this.getRangelandTable2()
    // this.getDegradationChart();
    this.getSteppeTableChart()
    // this.getVegetationCoverageChart();
    this.getGrasslandGradeChart()

    if (this.$route.query) {
      if (this.$route.query["pestIds"]) {
        this.getPestData(this.$route.query["pestIds"].join(","));
      } else {
        if (this.conf && this.conf["pestIds"]) {
          this.getPestData(this.conf["pestIds"]);
        } else {
          this.pestData = [];
        }
      }
      if (this.$route.query["resourceMapImage"]) {
        this.mapImages = JSON.parse(this.$route.query["resourceMapImage"]);
      } else {
        if (this.conf && this.conf["resourceMapImage"]) {
          this.mapImages = JSON.parse(this.conf["resourceMapImage"]);
        } else {
          this.mapImages = [];
        }
      }
    } else {
      if (this.conf) {
        if (this.conf["pestIds"]) {
          this.getPestData(this.conf["pestIds"]);
        } else {
          this.pestData = [];
        }
        if (this.conf["resourceMapImage"]) {
          this.mapImages = JSON.parse(this.conf["resourceMapImage"]);
        } else {
          this.mapImages = [];
        }
      }
    }




    console.log(this.mapImages, "==============")
  },
  methods: {

    getW() {
      this.w = document.getElementsByClassName('imageBox6')[0].clientWidth
    },

    getH() {
      this.h = document.getElementsByClassName('imageBox6')[0].clientHeight
    },
    changeActiveComponents(val) {
      //修改父组件传来的值
      this.$emit("changeActiveComponents", val);
    },

    getPestData(ids) {

    },

    getAreaAndType() {
      api.getAreaAndType(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          this.areaAndType.grasslandArea = res.data.grasslandArea
            ? res.data.grasslandArea
            : "-";
          this.areaAndType.grasslandType = res.data.grasslandType
            ? res.data.grasslandType
            : "-";
          this.areaAndType.rangeland = res.data.rangeland ? res.data.rangeland : "-";
        }
      });
    },
    getRangelandChart() {
      api.getRangelandChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          // this.rangelandChart.xAxis.data = res.data.x;
          // this.rangelandChart.series.data = res.data.y;
          // if (res.data.x.length > 5) {
          //   this.rangelandChartX = res.data.x;
          //   this.rangelandChartY = res.data.y;
          //   this.rangelandChart.xAxis.data = res.data.x.slice(0, 5);
          //   this.rangelandChart.series.data = res.data.y.slice(0, 5);
          //   this.rangelandChartInterval = setInterval(this.chageRangelandChart, 3500)

          // } else {
            this.rangelandChart.xAxis.data = res.data.x;
            this.rangelandChart.series.data = res.data.y;
          // }
        }
      });
    },
    chageRangelandChart() {
      console.log("chageRangelandChart")
      this.rangelandChartIndex = this.rangelandChartIndex + 1 > this.rangelandChartX.length - 1 ? 0 : this.rangelandChartIndex + 1
      this.rangelandChart.xAxis.data.shift();
      this.rangelandChart.series.data.shift();
      this.rangelandChart.xAxis.data.push(this.rangelandChartX[this.rangelandChartIndex]);
      this.rangelandChart.series.data.push(this.rangelandChartY[this.rangelandChartIndex]);
    },
    getTypeChart() {
      api.getTypeChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          this.typeChart.series[0].data = res.data.data;
          // this.typeChart.series.data = res.data.y;
        }
      });
    },
    getRangelandTable() {
      api.getRangelandTable(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          this.config.data = res.data.data
          if (res.data.header) {
            res.data.header.forEach(e => {
              this.config.header.push(e)
            })
          }

          // this.config.header=res.data.header
          this.config = { ...this.config }
          console.log(this.config)
          // this.typeChart.series[0].data = res.data.data;
          // this.typeChart.series.data = res.data.y;
        }
      });
    },
    getRangelandTable2() {
      api.getRangelandTable2(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          this.config.data = res.data.data
          if (res.data.header) {
            res.data.header.forEach(e => {
              this.config.header.push(e)
            })
          }

          // this.config.header=res.data.header
          this.config = { ...this.config }

          this.tableColumn = res.data.header
          this.tableData = res.data.data
          this.tableCollect = res.data.collect

          console.log(this.config)
          // this.typeChart.series[0].data = res.data.data;
          // this.typeChart.series.data = res.data.y;
        }
      });
    },
    getGrasslandGradeChart() {
      api.getGrasslandGradeChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          this.grasslandGradeChart.xAxis.data = res.data.x;
          this.grasslandGradeChart.series.data = res.data.y;
        }
      });
    },
    getGrasslandClassChart() {
      api.getGrasslandClassChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          this.grasslandClassChart.xAxis.data = res.data.x;
          this.grasslandClassChart.series.data = res.data.y;
        }
      });
    },

    // getDegradationChart() {
    //   api.getDegradationChart(this.$route.params.systemSid).then((res) => {
    //     if (res.resp_code == "10000") {
    //       console.log(res.data,"pppppppppppppppp")
    //       this.grasslandClassChart.category = res.data.x;
    //       this.grasslandClassChart.lineData = res.data.y;
    //       this.degradationArea=res.data.area.sum
    //     }
    //   });
    // },

    getDegradationChart() {
      api.getDegradationChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          // this.degradationChart.xData = res.data.legend;
          this.degradationChart.series[0].data = res.data.data;
          this.degradationArea = res.data.area ? res.data.area.sum.toFixed(2) : "-";
        }
      });
    },

    getVegetationCoverageChart() {
      api.getVegetationCoverageChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {
          this.vegetationCoverageChart.xAxis.data = res.data.x;
          this.vegetationCoverageChart.series.data = res.data.y;
          this.avgCoverage = res.data.avgCoverage
            ? res.data.avgCoverage.avgCoverage.toFixed(2)
            : "-";
        }
      });
    },
    getSteppeTableChart() {
      api.getSteppeTableChart(this.$route.params.systemSid).then((res) => {
        if (res.resp_code == "10000") {


          let obj = [
            // { "name": "", "value": 0 },
            // { "name": "", "value": 0 },
            // { "name": "", "value": 0 },
            // { "name": "", "value": 0 },
            // { "name": "", "value": 0 }
          ]

          
          let o1=null
          let o2=null
          let o3=null
          let o4=null
          let o5=null


          if (res.data.data) {
            res.data.data.forEach((item) => {
              if (item.name.includes('Ⅰ等')) {
                o1={name:item.name,value:item.value.toFixed(2)}
                // obj[0].value = item.value.toFixed(2)
                // obj[0].name = item.name
              } else if (item.name.includes('Ⅱ等')) {
                o2={name:item.name,value:item.value.toFixed(2)}
                // obj[1].value = item.value.toFixed(2)
                // obj[1].name = item.name
              } else if (item.name.includes('Ⅲ等')) {
                o3={name:item.name,value:item.value.toFixed(2)}
                // obj[2].value = item.value.toFixed(2)
                // obj[2].name = item.name
              } else if (item.name.includes('Ⅳ等')) {
                o4={name:item.name,value:item.value.toFixed(2)}
                // obj[3].value = item.value.toFixed(2)
                // obj[3].name = item.name
              } else if (item.name.includes('Ⅴ等')) {
                o5={name:item.name,value:item.value.toFixed(2)}
                // obj[4].value = item.value.toFixed(2)
                // obj[4].name = item.name
              }

            })
            if(o1){
              obj.push(o1)
            }
            if(o2){
              obj.push(o2)
            }
            if(o3){
              obj.push(o3)
            }
            if(o4){
              obj.push(o4)
            }
            if(o5){
              obj.push(o5)
            }
            this.steppeTableChart.series[0].data = obj;
          }
        }
      });
    }
  },
  beforeDestroy(){
    console.log("销毁")
    if(this.rangelandChartInterval){
      clearInterval(this.rangelandChartInterval); 
    }
    

  }
};
</script>
  
<style lang="scss" scoped>
.image_box div:nth-last-child(1) {
  margin-right: 0% !important;
}

.image_box1 div:nth-last-child(1) {
  margin-right: 3% !important;
}

.image_box1 div:nth-child(1) {
  margin-left: 3% !important;
}

.image_box div:nth-child(1) {
  margin-left: 3% !important;
}

.pest_image /deep/ .el-carousel__button {
  width: 5px;
  height: 5px;
}

.pest_image /deep/ .el-carousel__indicators--horizontal {
  bottom: 15%;
}

.pest_image /deep/ .el-carousel__container {
  height: 100%;
}

.map_image /deep/ .el-carousel__arrow {
  font-weight: 800;
  font-size: 2vw;
  line-height: 2vw;
}

.map_image /deep/ .el-carousel__container {
  height: 100%;
}


.image_title {
  font-style: oblique;
  text-align: center;
  color: #fff;
  font-size: 1.5vw;
  height: 10%;
  line-height: 40px;
  font-weight: 500;
  text-shadow: 0 0 5px #000000, 0 0 5px #000000, 0 0 5px #000000;
}

.title_icon {
  transform: rotate(90deg);
  font-weight: 700;
  color: #00ffff;
}

.resource-title {
  color: #fff;
  font-size: 1.5vw;
  height: 40px;
  line-height: 40px;
  margin-top: -10px;
  font-weight: 500;
  text-shadow: 0 0 5px #000000, 0 0 5px #000000, 0 0 5px #000000;
}

.image_base {
  width: 100%;
  height: 100%;
  padding: 16px 16px 0 16px;
  background-image: url("../../../assets/large-screen-img/ditu.png");
  background-size: cover;
  background-position: center center;
}
</style>
<style >
 .el-image-viewer__mask{
  opacity: 1 !important;
    background: #fff !important;
}
</style>
  